import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  updateDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAvdP6kpnkiZQiIu8QEqRZLuVw7GNKCVeM",
  authDomain: "guerra-digital.firebaseapp.com",
  projectId: "guerra-digital",
  storageBucket: "guerra-digital.appspot.com",
  messagingSenderId: "1023615699699",
  appId: "1:1023615699699:web:deec020a2165829bdd0586",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const saveClientInfos = async (personal) => {
  const docRef = await addDoc(collection(db, "clientes"), {
    nome: personal.name,
    cpf: personal.cpf,
    email: personal.email,
    telefone: personal.celular,
  });
  return docRef;
};

export { saveClientInfos };
